var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7746 7.10007C17.4329 7.10007 17.1496 6.81673 17.1496 6.47507V4.9584C17.1496 4.35007 16.6579 3.8584 16.0496 3.8584H3.94961C3.34128 3.8584 2.84961 4.35007 2.84961 4.9584V6.4834C2.84961 6.82507 2.56628 7.1084 2.22461 7.1084C1.88294 7.1084 1.59961 6.82507 1.59961 6.47507V4.9584C1.59961 3.6584 2.65794 2.6084 3.94961 2.6084H16.0496C17.3496 2.6084 18.3996 3.66673 18.3996 4.9584V6.4834C18.3996 6.82507 18.1246 7.10007 17.7746 7.10007Z",
    fill: "#093554"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3917C9.65833 18.3917 9.375 18.1084 9.375 17.7667V3.92505C9.375 3.58338 9.65833 3.30005 10 3.30005C10.3417 3.30005 10.625 3.58338 10.625 3.92505V17.7667C10.625 18.1167 10.3417 18.3917 10 18.3917Z",
    fill: "#093554"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2835 18.3916H6.7168C6.37513 18.3916 6.0918 18.1083 6.0918 17.7666C6.0918 17.4249 6.37513 17.1416 6.7168 17.1416H13.2835C13.6251 17.1416 13.9085 17.4249 13.9085 17.7666C13.9085 18.1083 13.6251 18.3916 13.2835 18.3916Z",
    fill: "#093554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.56808879207c06ffeb4b74e26e9ad50f.svg";
export { ForwardRef as ReactComponent };